module.exports = "<aside class=\"sidebar\" id=\"tray\" ng-click=\"onPageClick($event)\">\n    <div ui-view></div>\n</aside>\n\n<span class=\"trayViewMask\" ng-click=\"close()\"></span>\n"


//////////////////
// WEBPACK FOOTER
// ../~/noop-loader!./pages/xo-sidebar/template.html
// module id = ../node_modules/noop-loader/index.js!./pages/xo-sidebar/template.html
// module chunks = 1